var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67473 14.5084L7.64648 16.5367M6.48747 17.6957L7.64648 16.5367L6.48747 17.6957ZM12.0565 12.1267C12.3517 12.4259 12.7032 12.6638 13.0908 12.8266C13.4783 12.9894 13.8942 13.0739 14.3146 13.0753C14.7349 13.0767 15.1514 12.995 15.54 12.8348C15.9287 12.6746 16.2818 12.4391 16.579 12.1418C16.8762 11.8446 17.1117 11.4915 17.272 11.1029C17.4322 10.7142 17.5139 10.2978 17.5125 9.87742C17.5111 9.45707 17.4266 9.04114 17.2637 8.6536C17.1009 8.26606 16.8631 7.91455 16.5639 7.61931C15.9627 7.03873 15.1576 6.71747 14.3219 6.72473C13.4862 6.73199 12.6868 7.06719 12.0959 7.65814C11.5049 8.24908 11.1697 9.04849 11.1625 9.88417C11.1552 10.7199 11.4765 11.525 12.0571 12.1261L12.0565 12.1267ZM12.0565 12.1267L9.67473 14.5084L12.0565 12.1267ZM9.67473 14.5084L11.4132 16.2469L9.38498 18.2752L7.64648 16.5367L9.67473 14.5084Z",
    stroke: "#E2E1EA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.6092b5ded819aedcb5e0b96eda311e75.svg";
export { ForwardRef as ReactComponent };